import { Box, Button, CircularProgress } from "@mui/material";
import { TDetalheProcessoTarefasArquivos } from "../../types/api/bpm/detalhar-processo";
import { enqueueSnackbar } from "notistack";
import DownloadIcon from '@mui/icons-material/Download';
import { useMutation } from "react-query";
import axiosClient from "../../lib/axios";

export default function BtnBaixarTodosArquivos({
    arquivos,
    codigo
}: BtnBaixarTodosArquivosProps) {

    const { mutate: baixarTodosArquivos, isLoading: isLoadingBaixarTodos } = useMutation({
        mutationKey: 'baixar-todos-arquivos',
        mutationFn: () => axiosClient.get(`/baixar-todos-arquivos`, {
            params: { ids: arquivos.map(i => i.id) },
            responseType: 'blob'
        }),
        onError: (error) => {
            console.error(error);
            enqueueSnackbar("Error ao baixar os arquivos", { variant: "error" })
        },
        onSuccess: ({ data }) => {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `arquivos_tarefas_processo_${codigo}.zip`);

            document.body.appendChild(link);
            link.click();

            link.parentNode?.removeChild(link);
        }
    });

    return (
        <Box display="flex" mt={1} alignItems="center">
            <Button
                variant="text"
                size="small"
                startIcon={<DownloadIcon />}
                onClick={() => baixarTodosArquivos()}
                disabled={isLoadingBaixarTodos}
            >
                {
                    isLoadingBaixarTodos &&
                    <CircularProgress size={15} sx={{ marginRight: 1 }} />
                }
                Baixar arquivos
            </Button>
        </Box>
    )
}

interface BtnBaixarTodosArquivosProps {
    arquivos: TDetalheProcessoTarefasArquivos[],
    codigo: string
}